import { useState } from 'react';
import ActionNotification from '../../../../../components/Assets/ActionNotification';
import PasswordRecoveryLink from './PasswordRecoveryLink';
import PasswordResetInit from './PasswordResetInit';
import styles from './loginContent.module.scss';
import LoginForm from './loginForm/LoginForm';

interface ISigniInProps {
  className: string;
}

function LoginContent({ className }: ISigniInProps) {
  const [passwordResetInit, setPasswordResetInit] = useState(false);

  const handlePasswordRecoveryClick = () => {
    setPasswordResetInit(!passwordResetInit);
  };

  return (
    <div className={className}>
      <div className={styles.signIn}>
        <ActionNotification />
        {passwordResetInit ? (
          <>
            <PasswordResetInit />
            <PasswordRecoveryLink onClick={handlePasswordRecoveryClick} />
          </>
        ) : (
          <>
            <LoginForm />
            <PasswordRecoveryLink
              onClick={handlePasswordRecoveryClick}
              isSignInForm
            />
          </>
        )}
      </div>
    </div>
  );
}

export default LoginContent;
